import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GetSetDataService} from '../../services/get-set-data.service';
import {NgIf} from '@angular/common';
import {SingleReportSmallComponent} from '../single-report-small/single-report-small.component';

@Component({
  selector: 'app-favorite-reports',
  templateUrl: './favorite-reports.component.html',
  imports: [
    NgIf,
    SingleReportSmallComponent
  ],
  styleUrls: ['./favorite-reports.component.scss']
})
export class FavoriteReportsComponent implements OnInit {

  @Input() allData = [];
  @Input() showFavoriteComponent = true;
  @Input() userNiceName = '';

  constructor(private getSetData: GetSetDataService, private router: Router) {
  }

  ngOnInit() {
  }

  async logOutUser(event: any) {
    event.preventDefault();
    await this.getSetData.logoutUser();
    this.router.navigateByUrl('/reload');
  }
}
